
export const Langdata = [
   {
      language:"English",
      percentage: "90",
   },
   {
    language:"Urdu",
      percentage: 100,
   },
   {
    language:"Kasmiri",
      percentage: 100,
   },
   {
    language:"Hindi",
      percentage: 100,
   },
   {
    language:"Punjabi",
      percentage: 50,
   },
   
   
    
       
]
